import { createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setUser = createAction<{
  field: FlattenKeys<UserState>;
  value: any;
}>(actionTypes.SET_USER);

export const setCurrentUser = createAction<User>(actionTypes.SET_CURRENT_USER);

export const resetUser = createAction<void>(actionTypes.RESET_USER);

const userActions = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      setUser: <T extends FlattenKeys<UserState>>(
        field: T,
        value: DeepType<UserState, T>,
      ) => dispatch<void>(setUser({ field, value })),
      setCurrentUser: (payload: User) =>
        dispatch<void>(setCurrentUser(payload)),
      resetUser: () => dispatch<void>(resetUser()),
    },
  );

export default userActions;
